import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const OrderItemsAvailabilityBottomSheet = ({
  isOpen,
  onClose,
  items = [],
  onSubmit,
  isSubmitting = false,
}) => {
  const [availability, setAvailability] = useState({});

  useEffect(() => {
    const initial = {};
    items.forEach((item) => {
      initial[item.item_id] = String(
        Math.min(Number(item.quantity || 0), 9999)
      );
    });
    setAvailability(initial);
  }, [items]);

  const handleQtyChange = (itemId, value) => {
    if (!/^\d{0,4}$/.test(value)) return;
    setAvailability((prev) => ({ ...prev, [itemId]: value }));
  };

  const handleSubmit = () => {
    const formattedItems = items.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      quantity: Number(item.quantity),
      available_quantity: Number(availability[item.item_id]),
    }));

    onSubmit(formattedItems);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/50">
      {/* BACKDROP */}
      <div
        className="absolute inset-0"
        onClick={!isSubmitting ? onClose : undefined}
      />

      {/* BOTTOM SHEET */}
      <div className="relative bg-white w-full max-h-[90%] rounded-t-3xl px-4 py-6 overflow-hidden animate-slide-up">

        {/* DRAG HANDLE */}
        <div className="w-12 h-1 bg-gray-200 rounded-full mx-auto mb-4" />

        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">
            Item Availability
          </h2>
          <button onClick={onClose} disabled={isSubmitting}>
            <FontAwesomeIcon icon={faTimes} className="text-gray-500" />
          </button>
        </div>

        {/* COLUMN HEADERS */}
        <div className="flex text-xs font-bold text-gray-400 uppercase mb-2">
          <div className="flex-1">Item</div>
          <div className="w-12 text-center">Qty</div>
          <div className="w-20 text-center">Available</div>
        </div>

        {/* ITEMS LIST */}
        <div className="overflow-y-auto max-h-[50vh] pr-1">
          {items.map((item) => (
            <div
              key={item.item_id}
              className="flex items-center py-3 border-b border-gray-100"
            >
              {/* ITEM */}
              <div className="flex-1 flex items-center pr-2">
                <div className="w-10 h-10 bg-gray-100 rounded-lg mr-3 overflow-hidden">
                  {item.item_image ? (
                    <img
                      src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-full text-xs text-gray-400">
                      N/A
                    </div>
                  )}
                </div>

                <p className="text-sm font-medium text-gray-800 line-clamp-2">
                  {item.item_name}
                </p>
              </div>

              {/* ORDERED QTY */}
              <div className="w-12 text-center text-sm font-semibold text-gray-500">
                {Math.min(Number(item.quantity || 0), 999)}
              </div>

              {/* AVAILABLE INPUT */}
              <div className="w-20 text-center">
                <input
                  type="text"
                  value={availability[item.item_id] || ""}
                  onChange={(e) =>
                    handleQtyChange(item.item_id, e.target.value)
                  }
                  maxLength={4}
                  className="w-16 h-9 text-center border border-gray-200 rounded-lg bg-gray-50 font-bold"
                />
              </div>
            </div>
          ))}
        </div>

        {/* ACTIONS */}
        <div className="flex gap-4 pt-6">
          <button
            onClick={onClose}
            className="flex-1 py-3 text-gray-500 font-semibold"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className={`flex-2 bg-red-500 text-white font-bold py-3 rounded-xl shadow ${
              isSubmitting ? "opacity-70" : ""
            }`}
          >
            {isSubmitting ? "Updating..." : "Update Availability"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsAvailabilityBottomSheet;
